// initial state
const state = () => ({
  showQuizModal: false,
});

// getters
const getters = {};

// actions
const actions = {
  closeQuizModal({ commit }) {
    document.body.classList.remove('body--overlay');
    document.body.classList.remove('body--overlay-modal');
    commit('setShowQuizModal', false);
  },
  openQuizModal({ commit }) {
    document.body.classList.add('body--overlay');
    document.body.classList.add('body--overlay-modal');
    commit('setShowQuizModal', true);
  }
};

// mutations
const mutations = {
  setShowQuizModal(state, showQuizModal) {
    state.showQuizModal = showQuizModal;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
